'use client'

import React from 'react'
import type { LucideIcon } from 'lucide-react'

interface BlogCTACardProps {
  href: string
  label: string
  title: string
  description: string
  buttonText: string
  ButtonIcon?: LucideIcon
  SideIcon?: LucideIcon
  gradient?: string
  buttonColor?: string
}

export default function BlogCTACard({
  href,
  label,
  title,
  description,
  buttonText,
  ButtonIcon,
  SideIcon,
  gradient = 'from-[#0077b3] via-[#7c3aed] to-[#d9097a]',
  buttonColor = 'text-[#0067a3]',
}: BlogCTACardProps) {
  return (
    <div data-blog-layout='narrow' className='my-8'>
      <a
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        className='block !no-underline !decoration-transparent group'
      >
        <div
          className={`relative overflow-hidden rounded-2xl bg-gradient-to-br ${gradient} p-8 md:p-10`}
        >
          <div className='flex items-center gap-8'>
            {/* Spaced with gap: the site's flex-row rule zeroes h3/p margins in
                any `flex*` parent, `flex-1` included. */}
            <div className='flex-1 min-w-0 flex flex-col items-start gap-3'>
              <span className='inline-block text-[11px] font-bold tracking-[1.5px] uppercase text-white'>
                {label}
              </span>
              <h3 className='text-xl md:text-2xl font-extrabold text-white leading-tight'>
                {title}
              </h3>
              <p className='text-sm md:text-[15px] text-white leading-relaxed'>
                {description}
              </p>
              <span
                className={`mt-2 inline-flex items-center gap-2 bg-white ${buttonColor} px-5 py-2.5 rounded-lg font-semibold text-sm group-hover:bg-white/95 transition-colors`}
              >
                {ButtonIcon && <ButtonIcon size={16} />}
                {buttonText}
              </span>
            </div>
            {SideIcon && (
              <div className='hidden md:flex items-center justify-center w-28 h-28 bg-white/15 rounded-2xl flex-shrink-0'>
                <SideIcon size={48} className='text-white/90' />
              </div>
            )}
          </div>
        </div>
      </a>
    </div>
  )
}
